export default __webpack_public_path__ + "static/media/a012-market-5.0a582e41.svg";